import React from 'react';
import css from './InstagramFeedCard.module.css';
import {FiHeart} from 'react-icons/fi'
import {FaRegHeart} from 'react-icons/fa'
import { ExternalLink } from '../../../../components';

function InstagramFeedCard({feed, url, index}) {
  return (
    <div className={css.imgWrapper} key={index}>
      <img src={feed.media_url} alt="" />
      <div className={css.heartOverly}>
        <ExternalLink href={url}>
          <FaRegHeart />
        </ExternalLink>
      </div>
    </div>
  )
}

export default InstagramFeedCard
